import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import Label from '@/components/Label';
import { columns } from './column';
import { HttpStatusCode } from '@/fetch/core/constant';
import { isEmpty } from 'lodash';
import { formatCurDateTime, formatDuration, showMsg } from '@/utils/util';
import { enumTranslator } from '@/utils';
import { request } from '@/fetch/core';
import moment from 'moment';
import './index.scss';
interface Props {
  vehicleName: string;
}
const EventRecord = (props: Props) => {
  const { vehicleName } = props;
  const [tableData, setTableData] = useState([]);

  const getEventList = async () => {
    try {
      const res = await request({
        path: '/monitor/web/guardian/alarm/list',
        method: 'POST',
        body: {
          pageNum: 1,
          pageSize: 100,
          startTime: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          vehicleName: vehicleName,
        },
      });
      if (res.code === HttpStatusCode.Success) {
        if (res.data) {
          !isEmpty(res.data?.list) && setTableData(res.data.list);
        }
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getEventList();
  }, []);
  const formatColumns = () => {
    return columns.map((col: any) => {
      switch (col.dataIndex) {
        case 'index':
          return {
            ...col,
            render: (text: any, record: any, index: number) => {
              return <>{index + 1}</>;
            },
          };
        case 'alarmEvent':
          return {
            ...col,
            render: (text: any, record: any, index: number) => {
              return (
                <Label
                  text={enumTranslator('ALARM_EVENT_ENUM', text)}
                  key={index}
                />
              );
            },
          };
        case 'eventDuration':
          return {
            ...col,
            render: (text: any, record: any) => {
              const currentDateTime = new Date();

              return record.endTimestamp ? (
                <>
                  {formatDuration(record.operateTimestamp, record.endTimestamp)}
                </>
              ) : (
                <>
                  {formatDuration(
                    record.operateTimestamp,
                    formatCurDateTime(currentDateTime),
                  )}
                </>
              );
            },
          };
        default:
          return col;
      }
    });
  };
  return (
    <>
      <div className='event-record-wrapper'>
        <Table
          columns={formatColumns()}
          dataSource={tableData}
          pagination={false}
          rowKey={'operateTimestamp'}
        />
      </div>
    </>
  );
};
export default React.memo(EventRecord);
